import React, { useState, useEffect } from 'react';
import '../styles/Hero.css';

const slides = [
  '/cl.png',
  '/al.png',
  '/ql.png',
  '/il.png',
  '/ml.png',
  
];

function Hero() {
  const [current, setCurrent] = useState(0);

  // Auto slide every 3 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);

  const prevSlide = () => {
    setCurrent((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const nextSlide = () => {
    setCurrent((prev) => (prev + 1) % slides.length);
  };

  return (
    <div className="hero">

      {/* Slider Image */}
      <img
        src={slides[current]}
        alt={`Slide ${current + 1}`}
        className="hero-image"
      />

      {/* Left Arrow */}
      <button className="arrow left-arrow" onClick={prevSlide}>
        &#8249;
      </button>

      {/* Right Arrow */}
      <button className="arrow right-arrow" onClick={nextSlide}>
        &#8250;
      </button>

      {/* Dots */}
      <div className="dots">
        {slides.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === current ? 'active' : ''}`}
            onClick={() => setCurrent(index)}
          />
        ))}
      </div>

    </div>
  );
}

export default Hero;